var map = {
	"./config/languages.json": 83242,
	"./localazy.json": 16411,
	"./translations/en.json": 88602,
	"./translations/es.json": 45385,
	"./translations/fr.json": 46833,
	"./translations/sl.json": 41018,
	"./translations/sr.json": 29948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95105;